const CONFIG = {
  API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_DOMAIN_KEY: process.env.REACT_APP_DOMAIN_KEY,
  S3_URL: process.env.REACT_APP_S3_URL,
};

export { CONFIG };
